var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDafiAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5318 0C15.7729 0 15.1577 0.60403 15.1577 1.34923V15.7196V7.53796C15.1577 7.53796 14.1718 6.89407 12.8603 6.46427C11.8809 6.14328 10.649 6.00416 9.89409 6.00413C4.44145 6.00413 0 10.3654 0 15.7196C0 21.0737 4.44145 25.4351 9.89409 25.4351C15.3467 25.4351 19.5904 21.0737 19.5904 15.7196V1.34923C19.5904 0.60403 18.9752 0 18.2163 0H16.5318ZM9.93242 10.3385C12.967 10.3385 15.138 12.7398 15.138 15.7196C15.138 17.1104 14.6648 18.3755 13.8517 19.3288C12.9229 20.4182 11.5506 21.1006 9.93242 21.1006C6.89786 21.1006 4.45236 18.6993 4.45233 15.7196C4.45233 12.7398 6.89786 10.3384 9.93242 10.3385Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.89409 6.00413C4.44145 6.00413 0 10.3654 0 15.7196C0 21.0737 4.44145 25.4351 9.89409 25.4351C15.3467 25.4351 19.5904 21.0737 19.5904 15.7196H15.1577V7.53796C15.0099 7.44279 14.9392 7.39049 14.7057 7.2643C13.2798 6.49353 11.66 6.00413 9.89409 6.00413ZM9.93242 10.3385C12.967 10.3385 15.138 12.7398 15.138 15.7196C15.138 17.1104 14.6648 18.3755 13.8517 19.3288C12.9229 20.4182 11.5506 21.1006 9.93242 21.1006C6.89786 21.1006 4.45236 18.6993 4.45233 15.7196C4.45233 12.7398 6.89786 10.3384 9.93242 10.3385Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -5.89613,
    y1: -4.72832,
    x2: 23.1106,
    y2: 21.5493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#605384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F0824"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -5.89613,
    y1: -4.72832,
    x2: 23.1106,
    y2: 21.5493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#605384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F0824"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDafiAdd);
export default __webpack_public_path__ + "static/media/DafiAdd.a6e0516c85c1851a000abb0fe9afa9c8.svg";
export { ForwardRef as ReactComponent };